export class OpnSupplierListModel {
  id: number;
  requestId: number;
  supplierId: number;
  name: string;
  pibVatJmbg: string;
  mb: string;
  email: string;
}


export class OpnSupplierListSaveModel {
  requestId: number;
  selectedIds:  any[];
}

